export default {
  FETCH_BLACKOUT_DATES_START: 'CALENDAR.FETCH_BLACKOUT_DATES_START',
  UPDATE_BLACKOUT_DATES_START: 'CALENDAR.UPDATE_BLACKOUT_DATES_START',
  UPDATE_BLACKOUT_DATES: 'CALENDAR.UPDATE_BLACKOUT_DATES',
  UPDATE_BLACKOUT_DATES_FAILURE: 'CALENDAR.UPDATE_BLACKOUT_DATES_FAILURE',
}
